import { useState, useEffect } from "react";
import { RpaServices } from "../services/RpaServices";
import { handleApiErrorResponses } from "../utils/ApisErrorHandling";
import { CircularProgress } from "@mui/material";
import CloseIcon from "../assets/crossIcon.svg";
const ShowErrorLogDetails = ({
  setOpen,
  selectedApplication,
  fromDate,
  toDate,
}) => {
  const [loading, setLoading] = useState(false);
  const [rpaErrorLogs, setRpaErrorLogs] = useState(null);
  const [searchKey, setSearchKey] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 10;
  const getRpaErrorLogs = async () => {
    setLoading(true);
    toDate = toDate ? toDate : new Date();
    try {
      const res = await RpaServices?.getRpaErrorLogsWithoutRequests(
        page,
        limit,
        searchKey,
        new Date(fromDate).toISOString(),
        new Date(toDate).toISOString(),
        selectedApplication?.applicationId,
        selectedApplication?.errorCode
      );
      setRpaErrorLogs(res?.data?.logs);
      setTotalPages(res?.data?.totalPages);
    } catch (error) {
      handleApiErrorResponses(error);
    }
    setLoading(false);
  };
  useEffect(() => {
    getRpaErrorLogs();
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div className="fixed h-screen w-screen top-0 left-0 flex justify-center items-center bg-[#017C5780] z-[1201] ">
      <div className=" relative h-[70%] w-[80%] bg-white p-10 rounded-[20px]">
        <div
          className="absolute top-4 right-5 cursor-pointer"
          onClick={() => setOpen(false)}
        >
          <img src={CloseIcon} alt="close-icon" />
        </div>
        <div className="font-semibold text-xl">Error Logs</div>
        {loading ? (
          <div className="h-[50%] flex justify-center items-center">
            <CircularProgress />
          </div>
        ) : (
          <div className="h-[100%]">
            <div
              className={`grid grid-cols-5  text-[#797979] text-[18px] px-4 mt-5`}
            >
              <div>
                <div className="text-[#191919] font-semibold mb-4">
                  Application ID
                </div>
              </div>

              <div>
                <div className="text-[#191919] font-semibold mb-4">
                  {" "}
                  Error Code
                </div>{" "}
              </div>
              <div className="col-span-2">
                <div className="text-[#191919] font-semibold mb-4">
                  {" "}
                  Error Reason
                </div>{" "}
              </div>

              <div>
                <div className="text-[#191919] font-semibold mb-4"> Date</div>{" "}
              </div>
            </div>
            <div className="h-[80%] overflow-y-auto">
              {rpaErrorLogs && rpaErrorLogs.length > 0 ? (
                rpaErrorLogs?.map((error, idx) => {
                  return (
                    <div
                      key={idx}
                      className={`py-6 px-8 rounded-[16px] ${
                        idx % 2 === 1 ? "bg-white" : "bg-[#F9F9F9]"
                      }`}
                    >
                      <div
                        className={`grid grid-cols-5  text-[#797979] text-[18px] `}
                      >
                        <div>
                          <div>{error?.applicationId || "--"}</div>
                        </div>

                        <div>
                          <div>{error?.errorCode || "--"}</div>
                        </div>
                        <div className="col-span-2">
                          <div>{error?.errorReason || "--"}</div>
                        </div>
                        <div>
                          <div>
                            {error?.createdAt
                              ? new Date(error?.createdAt).toLocaleString(
                                  "en-GB",
                                  {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    second: "2-digit",
                                    hour12: true,
                                  }
                                )
                              : "--"}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="h-[300px] text-xl flex justify-center items-center font-semibold">
                  No Error Logs Found
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ShowErrorLogDetails;
